var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLabs = function SvgLabs(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18488",
    "data-name": "Group 18488",
    transform: "translate(-513 -1367)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18487",
    "data-name": "Group 18487",
    transform: "translate(513 1367)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11894",
    "data-name": "Group 11894"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11893",
    "data-name": "Group 11893",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7885",
    "data-name": "Path 7885",
    d: "M24.5,0A24.5,24.5,0,1,1,0,24.5,24.5,24.5,0,0,1,24.5,0Z",
    fill: "#f9f9f9"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "noun_1318592_cc",
    transform: "translate(512 1371.6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17177",
    "data-name": "Group 17177",
    transform: "translate(14.896 7.4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10135",
    "data-name": "Path 10135",
    d: "M15.381,28.663a2.675,2.675,0,0,0-.1,2.926A3.085,3.085,0,0,0,18,33.1H34.49A3.124,3.124,0,0,0,37.2,31.589a2.675,2.675,0,0,0-.1-2.926L29.519,17.5v-5.73h.775a1.962,1.962,0,0,0,2.034-1.9V9.33A1.986,1.986,0,0,0,30.294,7.4H22.224a1.967,1.967,0,0,0-2.033,1.93v.543a1.962,1.962,0,0,0,2.033,1.9H23v5.7ZM36.62,31.287a2.375,2.375,0,0,1-2.13,1.176H17.964a2.437,2.437,0,0,1-2.13-1.176,2.159,2.159,0,0,1,.065-2.322L16.963,27.4H35.426l1.065,1.568A2.1,2.1,0,0,1,36.62,31.287ZM23.289,11.17h-1.1a1.354,1.354,0,0,1-1.388-1.3V9.33A1.38,1.38,0,0,1,22.192,8h8.069A1.359,1.359,0,0,1,31.649,9.33v.543a1.355,1.355,0,0,1-1.388,1.3h-1.1a.3.3,0,0,0-.323.3v6.092a.223.223,0,0,0,.065.151l6.165,9.048H17.383l6.165-9.048c.032-.06.065-.09.065-.151V11.472A.313.313,0,0,0,23.289,11.17Z",
    transform: "translate(-14.896 -7.4)",
    fill: "#6c6c6c"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLabs, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/labs.85fcbe10.svg";
export { ForwardRef as ReactComponent };